module.exports = __webpack_public_path__ + "img/ch11.16870fc7.jpg";